import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const CardContainerStyle = styled.div`
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 8px;
  width: 100%;
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.4;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 8px 15px;
  margin: 0px 0px 0px 0px;
`;

const Children = styled.div`
  flex: 2;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;

const SelectContainer = styled.div`
  border-top: 1px solid ${theme.colors.themeColor};
`;
const SelectChildContainer = styled.div`
  padding: 15px 0px 15px 0px;
  display: flex;
  gap: 10px;
  justify-content: center;
`;
const THeading = styled.span`
  font-weight: bold;
`;
const TableContainer = styled.div`
  padding: 10px;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
const Thead = styled.thead``;
const Tbody = styled.tbody``;

const Tr = styled.tr`
  border-bottom: 1px solid ${theme.colors.borderColor};
`;
const Th = styled.th`
  font-size: 11px;
  font-weight: bold;
  text-align: left;
  padding: 8px;
`;

const Td = styled.td`
  font-size: 11px;
  padding: 5px;
  font-weight: normal;
`;

const NoData = styled.td`
  font-size: 11px;
  padding: 3px;
  font-weight: bold;
  text-align: center;
  color: #999;
  top: 50;
`;
const TR = styled.tr``;

const Yes = styled.span`
  color: green;
  font-weight: bold;
`;
const No = styled.span`
  color: red;
  font-weight: bold;
`;
const EmailContainer = styled.div``;

const Button = styled.button`
  min-width: 90px;
  height: 25px;
  border-radius: 5px;
  font-size: 12px;
  color: black;
  cursor: pointer;
  background: white;
  outline: none;
  border: 1px solid black;
  transition: all 0.3s ease;
  &:hover {
    color: ${theme.colors.themeColor};
    background: white;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
  @media (max-width: 600px) {
    min-width: 70px;
    height: 22px;
    font-size: 11px;
    padding: 2px 6px;
  }

  @media (max-width: 400px) {
    min-width: 60px;
    height: 20px;
    font-size: 10px;
    padding: 1px 4px;
  }
`;

const SC = {
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  CardContainerStyle,
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  NoData,
  TR,
  Yes,
  No,
  THeading,
  SelectContainer,
  SelectChildContainer,
  EmailContainer,
  Button,
};

export default SC;
